module.exports = __webpack_public_path__ + "static/media/sanguo.f2912125.mp4";